class Accordion {
  constructor(trigger) {
    this.triggerEl = trigger;
    this.initialize();
  }

  initialize() {
    this.triggerEl.addEventListener('click', event => {
      if (event.target.nodeName !== 'A') {
        const status = this.checkStatus(this.triggerEl);
        if (status === 'false') {
          this.openAccordion(this.triggerEl);
        } else if (status === 'true') {
          this.closeAccordion(this.triggerEl);
        }
      }
    });

    this.triggerEl.addEventListener('mouseover', event => {
      if (event.target.nodeName === 'A') {
        this.triggerEl.classList.add('reset-chevron');
      } else {
        this.triggerEl.classList.remove('reset-chevron');
      }
    });

    // Accordions with the false aria attribute should be closed on first paint
    if (this.checkStatus(this.triggerEl) === 'false') {
      this.closeAccordion(this.triggerEl);
    }

    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Compare URL hash if present to current trigger.
      let hash = window.location.hash.replace('#', '');
      hash = `${hash}-content`;
      const contentId = this.triggerEl.getAttribute('data-collapsible');
      if (hash === contentId) {
        this.triggerEl.click();
        const offset = this.triggerEl.offsetTop;
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
        return false; // disable defuault browser anchor jump
      }
    }
  }

  checkStatus(triggerEl) {
    const status = triggerEl.getAttribute('aria-expanded');
    return status;
  }

  openAccordion(triggerEl) {
    const contentId = triggerEl.getAttribute('data-collapsible');
    const contentEl = document.getElementById(contentId);
    triggerEl.setAttribute('aria-expanded', 'true');
    contentEl.setAttribute('aria-hidden', 'false');
  }

  closeAccordion(triggerEl) {
    const contentId = triggerEl.getAttribute('data-collapsible');
    const contentEl = document.getElementById(contentId);
    triggerEl.setAttribute('aria-expanded', 'false');
    contentEl.setAttribute('aria-hidden', 'true');
  }
}

export default Accordion;
